import type { WabunkaReservationQuestionAnswerViewModel } from '@/models/wabunka/wabunkaReservationQuestionAnswer';
import type { RequiredFieldCheck } from '@/wabunka-src/common/features/Reservation/core/requiredFields/fieldChecks';

export interface RequiredReservationQuestionFulfillment {
  /** 必須質問のうち回答済みの数 */
  answered: number;
  /** 必須質問の数。任意質問は数えない */
  total: number;
  isFulfilled: boolean;
}

const parseSelectedOptions = (answer: string): string[] => {
  try {
    const parsed = answer ? JSON.parse(answer) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const isChoiceQuestion = (questionAnswer: WabunkaReservationQuestionAnswerViewModel): boolean => questionAnswer.questionType === 'Radio' || questionAnswer.questionType === 'Checkbox';

/** 空白だけの自由記述は回答として数えない（充足率を実態に合わせるため。D-024） */
export const isReservationQuestionAnswered = (questionAnswer: WabunkaReservationQuestionAnswerViewModel): boolean => {
  if (isChoiceQuestion(questionAnswer)) return parseSelectedOptions(questionAnswer.answer).length > 0;
  return questionAnswer.answer.trim() !== '';
};

export const summarizeRequiredReservationQuestions = (questionAnswers: WabunkaReservationQuestionAnswerViewModel[]): RequiredReservationQuestionFulfillment => {
  const required = questionAnswers.filter((questionAnswer) => questionAnswer.isRequired);
  const answered = required.filter(isReservationQuestionAnswered).length;
  return { answered, total: required.length, isFulfilled: answered === required.length };
};

/** 選択式は何も選んでいない状態しか落ちないので常に空欄扱い。自由記述の空白だけは「入力したのに通らない」として理由を出す */
export const checkRequiredReservationQuestions: RequiredFieldCheck = (step2) =>
  step2.reservationQuestionAnswers.flatMap((questionAnswer, index) => {
    if (!questionAnswer.isRequired || isReservationQuestionAnswered(questionAnswer)) return [];
    const isChoice = isChoiceQuestion(questionAnswer);
    return [
      {
        fieldName: `step2.reservationQuestionAnswers[${index}]`,
        message: isChoice ? 'Please select one or more options' : 'Required fields',
        isBlank: isChoice || questionAnswer.answer === '',
      },
    ];
  });
